import { HOME_PATH, useGenerateCompanyPath } from '@/libs'
import { useTranslation } from 'react-i18next'
import {
  Button,
  FormErrorMessage,
  Input,
  Modal,
  ModalContent,
  ModalFooter,
  ModalProps,
  ModalTitle,
} from '@dashboard/ui'
import { dashboardClient, getErrorText } from '@/api'
import { generatePath } from 'react-router-dom'
import { useState } from 'react'
import { FieldGroup } from '@/ui'
import { TransferRequest } from '@/api/dashboard'

interface TransferGameModalProps extends ModalProps {}

export const TransferGameModal = (props: TransferGameModalProps) => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const { t } = useTranslation()
  const [helperText, setHelperText] = useState('')
  const [companyDesignationId, setCompanyDesignationId] = useState('')
  const isCompanyDesignationIdValid = companyDesignationId.trim() !== '' && companyDesignationId.trim() !== companyId

  const doTransferGame = async (event: React.FormEvent) => {
    event.preventDefault()
    try {
      setHelperText('')
      const transferRequest: TransferRequest = {
        to_company_id: companyDesignationId,
      }
      await dashboardClient.v1.transferGame(companyId, gameId, transferRequest)
      props.onClose()
      window.location.href = generatePath(HOME_PATH, {
        companyId: companyDesignationId,
        gameId: gameId,
      })
    } catch (error) {
      setHelperText(getErrorText(error) || 'Something went wrong')
    }
  }

  return (
    <Modal {...props}>
      <form onSubmit={doTransferGame}>
        <ModalContent>
          <ModalTitle>{t('game-settings.transfer-game.title')}</ModalTitle>
          <FieldGroup label={t('game-settings.transfer-game.sub-title')}>
            <Input
              autoFocus
              value={companyDesignationId}
              maxLength={32}
              onChange={e => setCompanyDesignationId(e.target.value)}
            />
            {helperText && <FormErrorMessage>{helperText}</FormErrorMessage>}
          </FieldGroup>
        </ModalContent>
        <ModalFooter>
          <Button variant="outline" color="secondary" size="sm" onClick={props.onClose}>
            {t('Cancel')}
          </Button>

          <Button size="sm" color="danger" type="submit" disabled={!isCompanyDesignationIdValid}>
            {t('game-settings.transfer-game')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
